const bg = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Зареждане...',
    error: 'Грешка',
    save: 'Запазване',
    cancel: 'Отказ',
    delete: 'Изтриване',
    edit: 'Редактиране',
    create: 'Създаване',
    add: 'Добавяне',
    remove: 'Премахване',
    close: 'Затваряне',
    confirm: 'Потвърждаване',
    apply: 'Прилагане',
    reset: 'Нулиране',
    search: 'Търсене',
    filter: 'Филтър',
    clear: 'Изчистване',
    back: 'Назад',
    next: 'Напред',
    previous: 'Предишен',
    submit: 'Изпращане',
    update: 'Актуализиране',
    refresh: 'Обновяване',
    export: 'Експортиране',
    import: 'Импортиране',
    download: 'Изтегляне',
    upload: 'Качване',
    print: 'Печат',
    copy: 'Копиране',
    yes: 'Да',
    no: 'Не',
    ok: 'ОК',
    done: 'Готово',
    select: 'Избиране',
    selectAll: 'Избиране на всички',
    deselectAll: 'Отмяна на избора',
    noResults: 'Няма намерени резултати',
    noData: 'Няма налични данни',
    required: 'Задължително',
    optional: 'По избор',
    actions: 'Действия',
    details: 'Подробности',
    overview: 'Преглед',
    summary: 'Обобщение',
    total: 'Общо',
    all: 'Всички',
    none: 'Няма',
    name: 'Име',
    type: 'Тип',
    status: 'Статус',
    date: 'Дата',
    time: 'Час',
    description: 'Описание',
    notes: 'Бележки',
    comments: 'Коментари',
    category: 'Категория',
    priority: 'Приоритет',
    nation: 'Държава',
    country: 'Страна',
    email: 'Електронна поща',
    phone: 'Телефон',
    address: 'Адрес',
    location: 'Местоположение',
    coordinates: 'Координати',
    latitude: 'Географска ширина',
    longitude: 'Географска дължина',
    from: 'От',
    to: 'До',
    createdAt: 'Създадено',
    updatedAt: 'Актуализирано',
    createdBy: 'Създадено от',
    modifiedBy: 'Променено от',
    active: 'Активен',
    inactive: 'Неактивен',
    enabled: 'Разрешено',
    disabled: 'Забранено',
    showing: 'Показване',
    of: 'от',
    page: 'Страница',
    perPage: 'на страница',
    rows: 'реда',
    items: 'елемента',
    results: 'резултата',
    sortBy: 'Сортиране по',
    ascending: 'Възходящо',
    descending: 'Низходящо',
    viewAll: 'Преглед на всички',
    viewDetails: 'Преглед на подробности',
    goBack: 'Назад',
    learnMore: 'Научете повече',
    seeMore: 'Вижте повече',
    showMore: 'Показване на повече',
    showLess: 'Показване на по-малко',
    expandAll: 'Разгъване на всички',
    collapseAll: 'Свиване на всички',
    copied: 'Копирано!',
    saved: 'Запазено!',
    deleted: 'Изтрито!',
    updated: 'Актуализирано!',
    created: 'Създадено!',
    success: 'Успех',
    warning: 'Предупреждение',
    info: 'Информация',
    danger: 'Опасност',
    unknown: 'Неизвестно',
    notAvailable: 'Недостъпно',
    never: 'Никога',
    today: 'Днес',
    yesterday: 'Вчера',
    tomorrow: 'Утре',
    now: 'Сега',
    ago: 'преди',
    justNow: 'току-що',
    minutesAgo: 'преди {{count}} мин',
    hoursAgo: 'преди {{count}} ч',
    daysAgo: 'преди {{count}} дни',
    monthsAgo: 'преди {{count}} мес',
    id: 'ID',
    version: 'Версия',
    language: 'Език',
    theme: 'Тема',
    darkMode: 'Тъмен режим',
    lightMode: 'Светъл режим',
    failedToLoad: 'Зареждането на данните е неуспешно',
    failedToSave: 'Запазването е неуспешно',
    failedToDelete: 'Изтриването е неуспешно',
    failedToUpdate: 'Актуализирането е неуспешно',
    confirmDelete: 'Наистина ли искате да изтриете това?',
    confirmAction: 'Сигурни ли сте?',
    unsavedChanges: 'Имате незапазени промени. Наистина ли искате да напуснете?',
    pageNotFound: '404 – Страницата не е намерена',
    pageNotFoundDesc: 'Страницата, която търсите, не съществува.',
    backToDashboard: 'Назад към таблото',
    characters: 'символа',
    maxCharacters: 'Максимум {{max}} символа',
    remaining: '{{count}} оставащи',
    selected: '{{count}} избрани',
    of_total: '{{count}} от {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Табло',
    requests: 'Заявки',
    transports: 'Транспорти',
    myPatients: 'Моите пациенти',
    statistics: 'Статистики',
    flow: 'Поток',
    resources: 'Resources',
    exercise: 'Учение',
    administration: 'Администрация',
    map: 'Карта',
    info: 'Информация',
    users: 'Потребители',
    assets: 'Ресурси',
    hubs: 'Възли',
    treatmentFacilities: 'Лечебни заведения',
    patientImport: 'Импорт на пациенти',
    assetTemplates: 'Шаблони за ресурси',
    dayTemplates: 'Дневни шаблони',
    announcementTicker: 'Лента за съобщения',
    exerciseStatistics: 'Статистики на учението',
    settings: 'Настройки',
    auditLog: 'Одитен журнал',
    exerciseControl: 'Управление на учението',
    dataSync: 'Синхронизация на данни',
    documentation: 'Документация',
    support: 'Поддръжка',
    about: 'За системата',
    assetContracts: 'Asset Contracts',
    notifications: 'Известия',
    schedules: 'Разписания',
    capacityPlanning: 'Планиране на капацитет',
    transportPlanning: 'Планиране на транспорт',
    transportBooking: 'Резервация на транспорт',
    flowDiagram: 'Диаграма на потока',
    changePassword: 'Смяна на парола',
    missions: 'Мисии',
    startPoints: 'Начални точки',
    hospital: 'Болница',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Вход',
    logout: 'Изход',
    logoutNow: 'Излизане сега',
    loggingIn: 'Влизане...',
    loginFailed: 'Входът е неуспешен',
    email: 'Електронна поща',
    password: 'Парола',
    username: 'Потребителско име',
    enterEmail: 'Въведете вашата електронна поща',
    enterPassword: 'Въведете вашата парола',
    enterUsername: 'Въведете вашето потребителско име',
    forgotPassword: 'Забравена парола?',
    forgotPasswordTitle: 'Забравена парола',
    forgotPasswordDesc: 'Въведете вашето потребителско име и електронна поща. Ако и двете съвпадат, администраторите ще бъдат уведомени за нулиране на паролата.',
    requestPasswordReset: 'Заявка за нулиране на парола',
    sending: 'Изпращане...',
    backToLogin: 'Назад към входа',
    pleaseWait: 'Моля, изчакайте преди да опитате отново.',
    requestFailed: 'Заявката е неуспешна',
    credentialsMatch: 'Ако данните съвпадат, администраторите са уведомени.',
    forAccess: 'За достъп, моля свържете се с вашия системен администратор.',
    changePassword: 'Смяна на парола',
    currentPassword: 'Текуща парола',
    newPassword: 'Нова парола',
    confirmPassword: 'Потвърждение на парола',
    passwordChanged: 'Паролата е променена успешно',
    passwordMismatch: 'Паролите не съвпадат',
    passwordTooShort: 'Паролата трябва да бъде поне 8 символа',
    changingPassword: 'Промяна...',
    mustChangePassword: 'Трябва да смените паролата си преди да продължите.',
    sessionExpiring: 'Сесията изтича',
    sessionExpireText: 'Вашата сесия ще изтече след <strong>{{time}}</strong>. Моля, запазете работата си и влезте отново.',
    dismiss: 'Затваряне',
    switchNation: 'Смяна на държава',
    returnTo: 'Връщане към {{nation}}',
    viewingAs: 'Преглеждате като',
    loggedInAs: 'влезли като {{nation}}',
    trainingMode: 'САМО ЗА УЧЕБНИ ЦЕЛИ',
    dedication: 'Създадено с любов и отдаденост на професията',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Системен администратор',
    excon: 'Контрольор на учението',
    eu: 'Координатор на ЕС',
    planner: 'Планировчик',
    hub: 'Мениджър на възел',
    nation: 'Държава',
    readOnly: 'Само за четене',
    systemAdmin: 'Системен администратор',
    transportPlanner: 'Планировчик на транспорт',
    systemRoles: 'Системни роли',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Чернова',
    underReview: 'В преглед',
    published: 'Публикувано',
    underSelection: 'В избор',
    accepted: 'Прието',
    planned: 'Планирано',
    inTransit: 'В транзит',
    completed: 'Завършено',
    closed: 'Затворено',
    withdrawn: 'Оттеглено',
    pending: 'В изчакване',
    rejected: 'Отхвърлено',
    cancelled: 'Отменено',
    active: 'Активен',
    inactive: 'Неактивен',
    review: 'Преглед',
    selection: 'Избор',
    transit: 'Транзит',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Персонал',
    material: 'Материал',
    equipment: 'Оборудване',
    other: 'Друго',
    news: 'Новини',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Рутинна',
    priority: 'Приоритетна',
    urgent: 'Спешна',
    immediate: 'Незабавна',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Влак',
    ship: 'Кораб',
    aircraft: 'Самолет',
    bus: 'Автобус',
    ambulance: 'Линейка',
    drone: 'Дрон',
    helicopter: 'Хеликоптер',
    ferry: 'Ферибот',
    other: 'Друго',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Табло',
    goodMorning: 'Добро утро',
    goodAfternoon: 'Добър ден',
    goodEvening: 'Добър вечер',
    lastLogin: 'Последен вход',
    infrastructure: 'Инфраструктура',
    transportAssets: 'Транспортни ресурси',
    treatmentFacilities: 'Лечебни заведения',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Статистики на заявки',
    viewAllRequests: 'Преглед на всички заявки',
    availableAssets: 'Налични ресурси',
    seated: 'Седнал',
    lying: 'Лежащ',
    intensive: 'Интензивен',
    notifications: 'Известия',
    markAllRead: 'Маркиране на всички като прочетени',
    noNotifications: 'Все още няма известия',
    notifiedWhenActivity: 'Ще бъдете уведомени при нова активност',
    viewDetailsBtn: 'Преглед на подробности',
    nationUsers: 'Потребители на държавата',
    user: 'Потребител',
    roles: 'Роли',
    noUsersFound: 'Не са намерени потребители',
    participatingNations: 'Участващи държави',
    exerciseDisclaimer: 'Тази система е предназначена само за учения. Въвеждайте единствено симулирани данни за учението. Работните процеси са адаптирани към сценария на учението и могат да се различават от реалните процедури. Правилата за ИТ сигурност и защита на данните остават напълно приложими.',
    notConfigured: 'Не е конфигурирано',
    requestCount: '{{count}} заявка(и)',
    clickToView: 'Натиснете за преглед',
    systemAdministration: 'Системна администрация',
    exerciseControlTitle: 'Управление на учението',
    euCoordination: 'Координация на ЕС',
    transportPlanningTitle: 'Планиране на транспорт',
    hubManagement: 'Управление на възли',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Нова заявка',
    myDrafts: 'Моите чернови',
    pendingReview: 'Чакащи преглед',
    activeTransports: 'Активни транспорти',
    myPatients: 'Моите пациенти',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Заявки',
    newRequest: 'Нова заявка',
    createRequest: 'Създаване на заявка',
    editRequest: 'Редактиране на заявка',
    requestDetail: 'Подробности за заявка',
    requestId: 'Идентификатор на заявка',
    fromNation: 'От държава',
    toNation: 'До държава',
    requestingNation: 'Заявяваща държава',
    receivingNation: 'Приемаща държава',
    category: 'Категория',
    urgency: 'Спешност',
    status: 'Статус',
    patients: 'Пациенти',
    patientCount: 'Брой пациенти',
    offers: 'Оферти',
    offerCount: 'Брой оферти',
    created: 'Създадено',
    updated: 'Актуализирано',
    submittedBy: 'Подадено от',
    reviewedBy: 'Прегледано от',
    description: 'Описание',
    medicalDetails: 'Медицински подробности',
    transportDetails: 'Транспортни подробности',
    additionalInfo: 'Допълнителна информация',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Точка на заминаване',
    arrivalPoint: 'Точка на пристигане',
    estimatedDeparture: 'Очаквано заминаване',
    estimatedArrival: 'Очаквано пристигане',
    submitForReview: 'Подаване за преглед',
    publish: 'Публикуване',
    startSelection: 'Започване на избор',
    acceptOffer: 'Приемане на оферта',
    markInTransit: 'Маркиране като в транзит',
    markCompleted: 'Маркиране като завършено',
    closeRequest: 'Затваряне на заявка',
    withdrawRequest: 'Оттегляне на заявка',
    withdraw: 'Оттегляне',
    revertToDraft: 'Връщане в чернова',
    deleteRequest: 'Изтриване на заявка',
    duplicateRequest: 'Дублиране на заявка',
    createFollowUp: 'Създаване на консолидирана заявка',
    followUpRequest: 'Консолидирана заявка',
    parentRequest: 'Първоначална заявка',
    childRequests: 'Консолидирани заявки',
    noRequests: 'Не са намерени заявки',
    noOffers: 'Все още няма оферти',
    addPatient: 'Добавяне на пациент',
    removePatient: 'Премахване на пациент',
    patientDetails: 'Данни за пациент',
    contactPerson: 'Лице за контакт',
    contactPhone: 'Телефон за контакт',
    contactEmail: 'Електронна поща за контакт',
    specialRequirements: 'Специални изисквания',
    medicalEquipment: 'Медицинско оборудване',
    accompaniment: 'Съпровождане',
    timeline: 'Хронология',
    history: 'История',
    addComment: 'Добавяне на коментар',
    writeComment: 'Напишете коментар...',
    postComment: 'Публикуване на коментар',
    posting: 'Публикуване...',
    noComments: 'Все още няма коментари',
    coverageBar: 'Покритие',
    covered: 'покрити',
    uncovered: 'непокрити',
    filterByStatus: 'Филтриране по статус',
    filterByCategory: 'Филтриране по категория',
    filterByNation: 'Филтриране по държава',
    searchRequests: 'Търсене на заявки...',
    confirmWithdraw: 'Наистина ли искате да оттеглите тази заявка?',
    confirmDelete: 'Наистина ли искате да изтриете тази заявка?',
    confirmPublish: 'Наистина ли искате да публикувате тази заявка? Тя ще бъде видима за всички държави.',
    confirmStartSelection: 'Наистина ли искате да започнете избора? Държавите ще могат да правят оферти.',
    warningStartSelection: 'Започването на избора ще направи тази заявка видима за всички участващи държави. Те ще могат да подават оферти за пациентите в тази заявка. Това действие не може да бъде отменено.',
    warningMakeOffer: 'С подаването на тази оферта вашата държава се ангажира да предостави предложената помощ. Това действие ще уведоми заявяващата държава и контрола на учението.',
    saveDraft: 'Запазване на чернова',
    saving: 'Запазване...',
    saveAndSubmit: 'Запазване и подаване',
    step: 'Стъпка {{number}}',
    generalInfo: 'Обща информация',
    patientInfo: 'Информация за пациент',
    logisticsInfo: 'Логистична информация',
    reviewSubmit: 'Преглед и подаване',
    requestTitle: 'Заглавие на заявка',
    requestDescription: 'Описание на заявка',
    numberOfPatients: 'Брой пациенти',
    typeOfAssistance: 'Вид помощ',
    medicalTreatment: 'Медицинско лечение',
    transportAssistance: 'Транспортна помощ',
    both: 'И двете',
    treatmentOnly: 'Само лечение',
    transportOnly: 'Само транспорт',
    validationErrors: 'Моля, коригирайте следните грешки:',
    fieldRequired: 'Това поле е задължително',
    selectExitHub: 'Изберете изходен възел',
    createExitHub: 'Създаване на изходен възел',
    backToRequests: 'Назад към заявки',
    noRequestsFound: 'Не са намерени заявки',
    createFirstRequest: 'Създайте първата си заявка, за да започнете',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Оферти',
    createOffer: 'Създаване на оферта',
    makeOffer: 'Подаване на оферта',
    manageOffers: 'Управление на оферти',
    offerDetail: 'Подробности за оферта',
    offerId: 'Идентификатор на оферта',
    offeringNation: 'Предлагаща държава',
    offerType: 'Вид оферта',
    treatment: 'Лечение',
    transport: 'Транспорт',
    combined: 'Комбинирана',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Оферта за лечение',
    transportOffer: 'Оферта за транспорт',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Избиране на пациенти',
    selectedPatients: 'Избрани пациенти',
    patientSelection: 'Избор на пациенти',
    offerConfiguration: 'Конфигурация на оферта',
    reviewOffer: 'Преглед на оферта',
    submitOffer: 'Подаване на оферта',
    submitting: 'Подаване...',
    acceptOffer: 'Приемане на оферта',
    rejectOffer: 'Отхвърляне на оферта',
    withdrawOffer: 'Оттегляне на оферта',
    noOffers: 'Няма налични оферти',
    noOffer: 'No Offer',
    offerStatus: 'Статус на оферта',
    offerDate: 'Дата на оферта',
    transportAsset: 'Транспортен ресурс',
    departureDate: 'Дата на заминаване',
    arrivalDate: 'Дата на пристигане',
    treatmentFacility: 'Лечебно заведение',
    capacity: 'Капацитет',
    availableCapacity: 'Наличен капацитет',
    totalCapacity: 'Общ капацитет',
    selectAsset: 'Избиране на ресурс',
    selectFacility: 'Избиране на заведение',
    offerNotes: 'Бележки към оферта',
    confirmAccept: 'Наистина ли искате да приемете тази оферта?',
    confirmReject: 'Наистина ли искате да отхвърлите тази оферта?',
    extendTransport: 'Удължаване на транспорт',
    transportExtension: 'Удължаване на транспорт',
    comparisonView: 'Сравнителен изглед',
    shortlist: 'Кратък списък',
    addToShortlist: 'Добавяне в краткия списък',
    removeFromShortlist: 'Премахване от краткия списък',
    leaveConfirmTitle: 'Напускане на тази страница?',
    leaveConfirmMessage: 'Имате незапазени промени. Наистина ли искате да напуснете?',
    stayOnPage: 'Оставане на страницата',
    leavePage: 'Напускане на страницата',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Транспорти',
    missionDetail: 'Подробности за транспорт',
    missionId: 'Идентификатор на транспорт',
    missionStatus: 'Статус на транспорт',
    createMission: 'Създаване на транспорт',
    overview: 'Преглед',
    patientsTab: 'Пациенти',
    transportsTab: 'Транспортни участъци',
    treatmentTab: 'Лечение',
    reviewTab: 'Преглед',
    departure: 'Заминаване',
    arrival: 'Пристигане',
    origin: 'Начало',
    destination: 'Дестинация',
    stops: 'Спирки',
    addStop: 'Добавяне на спирка',
    removeStop: 'Премахване на спирка',
    stopName: 'Име на спирка',
    stopType: 'Тип спирка',
    estimatedTime: 'Очаквано време',
    actualTime: 'Действително време',
    asset: 'Ресурс',
    driver: 'Водач',
    crew: 'Екипаж',
    noMissions: 'Не са намерени транспорти',
    completeMission: 'Завършване на транспорт',
    cancelMission: 'Отмяна на транспорт',
    startTransport: 'Стартиране на транспорт',
    missionChain: 'Транспортна верига',
    linkedMissions: 'Свързани транспорти',
    handover: 'Предаване',
    handoverPoint: 'Точка на предаване',
    pickupPoint: 'Точка на вземане',
    dropoffPoint: 'Точка на предаване',
    searchTransports: 'Търсене на транспорти...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Пациенти',
    myPatients: 'Моите пациенти',
    patientId: 'Идентификатор на пациент',
    firstName: 'Име',
    lastName: 'Фамилия',
    dateOfBirth: 'Дата на раждане',
    age: 'Възраст',
    gender: 'Пол',
    male: 'Мъж',
    female: 'Жена',
    other: 'Друг',
    nationality: 'Гражданство',
    diagnosis: 'Диагноза',
    condition: 'Състояние',
    stable: 'Стабилен',
    critical: 'Критичен',
    serious: 'Тежък',
    treatmentNeeded: 'Необходимо лечение',
    allergies: 'Алергии',
    medications: 'Медикаменти',
    bloodType: 'Кръвна група',
    weight: 'Тегло (кг)',
    infectious: 'Инфекциозен',
    mentalHealth: 'Психично здраве',
    mobility: 'Мобилност',
    ambulatory: 'Подвижен',
    wheelchair: 'Инвалидна количка',
    stretcher: 'Носилка',
    intensive: 'Интензивно лечение',
    oxygenRequired: 'Необходим кислород',
    ventilator: 'Вентилатор',
    medicalEscort: 'Медицинска ескорт',
    noPatients: 'Не са намерени пациенти',
    patientDetails: 'Данни за пациент',
    medicalHistory: 'Медицинска история',
    travelDocuments: 'Документи за пътуване',
    passport: 'Паспорт',
    pseudonymizedId: 'Псевдонимизиран идентификатор',
    sensitiveData: 'Чувствителни данни',
    journey: 'Път на пациента',
    assignedTo: 'Назначен на',
    currentLocation: 'Текущо местоположение',
    importPatients: 'Импорт на пациенти',
    exportPatients: 'Експорт на пациенти',
    seated: 'Седнал',
    lying: 'Лежащ',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Потребители',
    createUser: 'Създаване на потребител',
    editUser: 'Редактиране на потребител',
    deleteUser: 'Изтриване на потребител',
    username: 'Потребителско име',
    displayName: 'Показвано име',
    email: 'Електронна поща',
    password: 'Парола',
    role: 'Роля',
    roles: 'Роли',
    nation: 'Държава',
    active: 'Активен',
    lastLogin: 'Последен вход',
    createdAt: 'Създадено',
    isNation: 'Държава',
    isEU: 'ЕС',
    isAdmin: 'Администратор',
    isExcon: 'EXCON',
    isPlanner: 'Планировчик',
    isHub: 'Възел',
    isReadOnly: 'Само за четене',
    noUsers: 'Не са намерени потребители',
    confirmDelete: 'Наистина ли искате да изтриете този потребител?',
    resetPassword: 'Нулиране на парола',
    generatePassword: 'Генериране на парола',
    searchUsers: 'Търсене на потребители...',
    userCreated: 'Потребителят е създаден успешно',
    userUpdated: 'Потребителят е актуализиран успешно',
    userDeleted: 'Потребителят е изтрит успешно',
    selectNation: 'Изберете държава',
    mustChangePassword: 'Трябва да смени паролата при следващия вход',
    flagImage: 'Изображение на знаме',
    exportUsers: 'Експорт на потребители',
    importUsers: 'Импорт на потребители',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Ресурси',
    createAsset: 'Създаване на ресурс',
    editAsset: 'Редактиране на ресурс',
    deleteAsset: 'Изтриване на ресурс',
    assetName: 'Име на ресурс',
    assetType: 'Тип ресурс',
    capacitySeated: 'Капацитет (седнал)',
    capacityLying: 'Капацитет (лежащ)',
    capacityIntensive: 'Капацитет (интензивен)',
    owner: 'Собственик',
    operator: 'Оператор',
    baseLocation: 'Базово местоположение',
    range: 'Обхват',
    speed: 'Скорост',
    noAssets: 'Не са намерени ресурси',
    confirmDelete: 'Наистина ли искате да изтриете този ресурс?',
    searchAssets: 'Търсене на ресурси...',
    assetCreated: 'Ресурсът е създаден успешно',
    assetUpdated: 'Ресурсът е актуализиран успешно',
    assetDeleted: 'Ресурсът е изтрит успешно',
    exportAssets: 'Експорт на ресурси',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Възли',
    startPoints: 'Начални точки',
    createHub: 'Създаване на възел',
    editHub: 'Редактиране на възел',
    deleteHub: 'Изтриване на възел',
    hubName: 'Име на възел',
    hubType: 'Тип възел',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Входен възел',
    airport: 'Летище',
    seaport: 'Пристанище',
    railStation: 'Жп гара',
    roadPoint: 'Пътна точка',
    ucpmClassification: 'Класификация UCPM',
    icaoCode: 'Код ICAO',
    iataCode: 'Код IATA',
    noHubs: 'Не са намерени възли',
    confirmDelete: 'Наистина ли искате да изтриете този възел?',
    searchHubs: 'Търсене на възли...',
    nationAssignment: 'Назначаване на държава',
    assignNations: 'Назначаване на държави',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Лечебни заведения',
    createFacility: 'Създаване на заведение',
    editFacility: 'Редактиране на заведение',
    deleteFacility: 'Изтриване на заведение',
    facilityName: 'Име на заведение',
    facilityType: 'Тип заведение',
    hospitalName: 'Име на болница',
    bedCapacity: 'Капацитет легла',
    specialties: 'Специалности',
    availableBeds: 'Налични легла',
    totalBeds: 'Общо легла',
    contactPerson: 'Лице за контакт',
    noFacilities: 'Не са намерени лечебни заведения',
    confirmDelete: 'Наистина ли искате да изтриете това заведение?',
    searchFacilities: 'Търсене на заведения...',
    hubNationAssignment: 'Назначаване на възел-държава',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Разписания',
    createSchedule: 'Създаване на разписание',
    editSchedule: 'Редактиране на разписание',
    deleteSchedule: 'Изтриване на разписание',
    scheduleName: 'Име на разписание',
    scheduleType: 'Тип разписание',
    recurring: 'Повтарящо се',
    oneTime: 'Еднократно',
    frequency: 'Честота',
    daily: 'Дневно',
    weekly: 'Седмично',
    startDate: 'Начална дата',
    endDate: 'Крайна дата',
    departureTime: 'Час на заминаване',
    arrivalTime: 'Час на пристигане',
    stops: 'Спирки',
    addStop: 'Добавяне на спирка',
    noSchedules: 'Не са намерени разписания',
    bookings: 'Резервации',
    timeline: 'Хронология',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Известия',
    markAllRead: 'Маркиране на всички като прочетени',
    markAsRead: 'Маркиране като прочетено',
    markAsUnread: 'Маркиране като непрочетено',
    noNotifications: 'Няма известия',
    viewAll: 'Преглед на всички известия',
    settings: 'Настройки за известия',
    emailNotifications: 'Известия по електронна поща',
    inAppNotifications: 'Известия в приложението',
    notifyOn: 'Уведоми ме за',
    requestCreated: 'Нова заявка',
    requestPublished: 'Заявка публикувана',
    requestClosed: 'Заявка затворена',
    requestCompleted: 'Заявка завършена',
    commentAdded: 'Нов коментар',
    offerReceived: 'Получена оферта',
    offerAccepted: 'Оферта приета',
    statusChanged: 'Статусът е променен',
    selectionStarted: 'Изборът е започнал',
    missionCreated: 'Транспорт създаден',
    missionStatusUpdated: 'Транспорт актуализиран',
    transportPartnerNamed: 'Транспортен партньор',
    transportExtensionReceived: 'Удължаване на транспорт',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Настройки',
    general: 'Общи',
    system: 'Система',
    email: 'Електронна поща',
    sync: 'Синхронизация',
    security: 'Сигурност',
    appearance: 'Външен вид',
    systemName: 'Име на система',
    systemEmail: 'Системна електронна поща',
    maintenanceMode: 'Режим на поддръжка',
    readOnlyMode: 'Режим само за четене',
    emailEnabled: 'Електронна поща активирана',
    smtpHost: 'SMTP хост',
    smtpPort: 'SMTP порт',
    smtpUser: 'SMTP потребител',
    smtpPassword: 'SMTP парола',
    senderEmail: 'Електронна поща на подател',
    senderName: 'Име на подател',
    testEmail: 'Изпращане на тестова поща',
    syncEnabled: 'Синхронизация активирана',
    syncUrl: 'URL за синхронизация',
    syncApiKey: 'API ключ за синхронизация',
    settingsSaved: 'Настройките са запазени успешно',
    helpdesk: 'Помощен център',
    helpdeskTitle: 'Заглавие на помощен център',
    helpdeskEmail: 'Електронна поща на помощен център',
    helpdeskPhone: 'Телефон на помощен център',
    helpdeskInfo: 'Информация за помощен център',
    realLifeSupport: 'Поддръжка в реалния живот',
    trainingMode: 'Учебен режим',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Одитен журнал',
    action: 'Действие',
    user: 'Потребител',
    target: 'Цел',
    details: 'Подробности',
    timestamp: 'Времеви маркер',
    ipAddress: 'IP адрес',
    noLogs: 'Не са намерени одитни записи',
    searchLogs: 'Търсене на записи...',
    filterByAction: 'Филтриране по действие',
    filterByUser: 'Филтриране по потребител',
    exportLogs: 'Експорт на записи',
    exportCsv: 'Експорт в CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Управление на учението',
    currentDay: 'Текущ ден',
    exerciseDay: 'Ден на учението',
    nextDay: 'Следващ ден',
    previousDay: 'Предишен ден',
    resetExercise: 'Нулиране на учението',
    startExercise: 'Стартиране на учението',
    endExercise: 'Приключване на учението',
    dayReset: 'Нулиране на деня',
    confirmReset: 'Наистина ли искате да нулирате деня на учението? Това ще изтрие всички данни за текущия ден.',
    resetInProgress: 'Нулиране в ход...',
    maintenanceMode: 'Режим на поддръжка',
    enableMaintenance: 'Активиране на поддръжка',
    disableMaintenance: 'Деактивиране на поддръжка',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Синхронизация на данни',
    syncStatus: 'Статус на синхронизация',
    lastSync: 'Последна синхронизация',
    pendingItems: 'Чакащи елементи',
    syncNow: 'Синхронизиране сега',
    syncing: 'Синхронизиране...',
    syncSuccess: 'Синхронизацията завърши успешно',
    syncFailed: 'Синхронизацията е неуспешна',
    outbox: 'Изходящи',
    inbox: 'Входящи',
    configuration: 'Конфигурация',
    targetUrl: 'Целеви URL',
    apiKey: 'API ключ',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Карта',
    layers: 'Слоеве',
    requests: 'Заявки',
    hubs: 'Възли',
    facilities: 'Заведения',
    routes: 'Маршрути',
    showAll: 'Показване на всички',
    hideAll: 'Скриване на всички',
    zoomIn: 'Увеличаване',
    zoomOut: 'Намаляване',
    resetView: 'Нулиране на изгледа',
    satellite: 'Сателит',
    terrain: 'Терен',
    offline: 'Офлайн',
    online: 'Онлайн',
    tilesOffline: 'Плочките на картата се обслужват локално',
    tilesOnline: 'Плочките на картата се зареждат от онлайн сървъри',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Статистики',
    overview: 'Преглед',
    requestsByStatus: 'Заявки по статус',
    requestsByCategory: 'Заявки по категория',
    requestsByNation: 'Заявки по държава',
    offersByStatus: 'Оферти по статус',
    patientsByCondition: 'Пациенти по състояние',
    transportsByStatus: 'Транспорти по статус',
    timeline: 'Хронология',
    totalRequests: 'Общо заявки',
    totalOffers: 'Общо оферти',
    totalPatients: 'Общо пациенти',
    totalTransports: 'Общо транспорти',
    averageResponseTime: 'Средно време за отговор',
    completionRate: 'Степен на завършване',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Статистики на учението',
    overview: 'Преглед',
    byCategory: 'По категория',
    byNation: 'По държава',
    byDay: 'По ден',
    totalPatientsMoved: 'Общо транспортирани пациенти',
    totalRequestsProcessed: 'Общо обработени заявки',
    averageProcessingTime: 'Средно време за обработка',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Диаграма на потока',
    sankey: 'Санки',
    nodeGraph: 'Графика на възли',
    refresh: 'Обновяване',
    noData: 'Няма налични данни за потока',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'За системата',
    version: 'Версия',
    systemInfo: 'Системна информация',
    buildDate: 'Дата на изграждане',
    environment: 'Среда',
    description: 'ARCOS — Усъвършенствана система за комуникация на заявки',
    subtitle: 'Помощ на пострадали и медицински операции',
    whatIsArcos: 'Какво е ARCOS? – Обяснение за участниците в учението',
    arcosDesc1: 'ARCOS е цифров инструмент, използван в това учение за подкрепа и структуриране на международната комуникация, заявките и координационните процеси между участващите актьори. Важно е да се разбере, че ARCOS не е оперативна система и не замества реални платформи като CECIS или EWRS.',
    arcosDesc2: 'Вместо това ARCOS предоставя опростено, ориентирано към учението представяне на основните принципи зад тези системи.',
    arcosUsedFor: 'По време на учението ARCOS се използва за представяне на типични процеси като:',
    arcosUsedForItem1: 'подаване и управление на заявки за помощ (напр. медицинска подкрепа, персонал или материали),',
    arcosUsedForItem2: 'координиране и отговаряне на предложения за подкрепа от други нации или организации,',
    arcosUsedForItem3: 'проследяване на статуса и напредъка на заявките,',
    arcosUsedForItem4: 'и представяне на опростени транспортни или евакуационни работни потоци.',
    arcosDesc3: 'Работните потоци в ARCOS са умишлено опростени и адаптирани към специфичните учебни цели на учението.',
    arcosDesc4: 'Целта на ARCOS не е да симулира перфектна или пълна реална система. Вместо това цели да осигури ясно, структурирано и споделено разбиране за принципите на работа на многонационалните координационни процеси.',
    arcosDesc5: 'Ако определени елементи или работни потоци в ARCOS се различават от реалните процедури, които може да познавате, това е очаквано.',
    facilitatedBy: 'С подкрепата на MMCC-E',
    dhcInitiative: 'Digital Health Corner (DHC) е съвместна инициатива на:',
    dhcAuthor1: 'Sven Giegerich — Германски въоръжени сили',
    dhcAuthor2: 'Mohamad Haji — Белгийска отбрана',
    dhcConviction: 'Родена от убеждението, че иновацията процъфтява там, където страстта среща прагматизма.',
    dhcInspired: 'Вдъхновени от първоначалната искра на MMCC-E, ние се заехме да създадем прости, но ефективни решения, базирани на съществуващи системи.',
    dhcLove: 'Правим го, защото обичаме работата си и вярваме, че цифровите идеи могат да преобразят сътрудничеството във военното здравеопазване.',
    dhcOpen: 'DHC е отворена платформа: свободна от йерархии, отворена за идеи, движена от любопитство и дух на сътрудничество.',
    dhcClosing: 'Digital Health Corner – където любопитството среща сътрудничеството.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Документация',
    gettingStarted: 'Първи стъпки',
    userGuide: 'Ръководство за потребителя',
    faq: 'Често задавани въпроси',
    troubleshooting: 'Отстраняване на проблеми',
    apiReference: 'Справочник за API',
    downloadTemplate: 'Изтегляне на шаблон',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Импорт на пациенти',
    uploadFile: 'Качване на файл',
    selectFile: 'Избиране на файл',
    preview: 'Предварителен преглед',
    importNow: 'Импортиране сега',
    importing: 'Импортиране...',
    importSuccess: '{{count}} пациента импортирани успешно',
    importFailed: 'Импортирането е неуспешно',
    downloadTemplate: 'Изтегляне на шаблон',
    dragDrop: 'Плъзнете и пуснете файл тук или натиснете за избор',
    supportedFormats: 'Поддържани формати: XLSX, XLS, CSV',
    rowsFound: '{{count}} намерени реда',
    validRows: '{{count}} валидни реда',
    invalidRows: '{{count}} невалидни реда',
    duplicateRows: '{{count}} дублирани реда',
    previewData: 'Предварителен преглед на данни',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Планиране на транспорт',
    planRoute: 'Планиране на маршрут',
    routeBuilder: 'Конструктор на маршрут',
    addWaypoint: 'Добавяне на междинна точка',
    removeWaypoint: 'Премахване на междинна точка',
    estimatedDuration: 'Очаквана продължителност',
    distance: 'Разстояние',
    selectVehicle: 'Избиране на превозно средство',
  },

  transportBooking: {
    title: 'Резервация на транспорт',
    bookTransport: 'Резервиране на транспорт',
    availableSlots: 'Налични места',
    bookingConfirmed: 'Резервацията е потвърдена',
    cancelBooking: 'Отмяна на резервация',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Планиране на капацитет',
    totalCapacity: 'Общ капацитет',
    usedCapacity: 'Използван капацитет',
    availableCapacity: 'Наличен капацитет',
    utilizationRate: 'Степен на използване',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Шаблони за ресурси',
    dayTemplates: 'Дневни шаблони',
    createTemplate: 'Създаване на шаблон',
    editTemplate: 'Редактиране на шаблон',
    deleteTemplate: 'Изтриване на шаблон',
    templateName: 'Име на шаблон',
    applyTemplate: 'Прилагане на шаблон',
    noTemplates: 'Не са намерени шаблони',
    confirmDelete: 'Наистина ли искате да изтриете този шаблон?',
    confirmApply: 'Наистина ли искате да приложите този шаблон? Това ще презапише съществуващите данни.',
    exportTemplates: 'Експорт на шаблони',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Лента за съобщения',
    createAnnouncement: 'Създаване на съобщение',
    editAnnouncement: 'Редактиране на съобщение',
    deleteAnnouncement: 'Изтриване на съобщение',
    message: 'Съобщение',
    startTime: 'Начален час',
    endTime: 'Краен час',
    active: 'Активно',
    noAnnouncements: 'Няма съобщения',
    confirmDelete: 'Наистина ли искате да изтриете това съобщение?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Търсене...',
      noResults: 'Няма намерени резултати',
      showing: 'Показване от {{from}} до {{to}} от {{total}}',
      rowsPerPage: 'Реда на страница',
      previousPage: 'Предишна страница',
      nextPage: 'Следваща страница',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Потвърждаване',
      cancel: 'Отказ',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Незапазени промени',
      message: 'Имате незапазени промени. Наистина ли искате да напуснете тази страница?',
      stay: 'Оставане на страницата',
      leave: 'Напускане на страницата',
    },
    // EmptyState
    emptyState: {
      noData: 'Няма налични данни',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Нещо се обърка',
      message: 'Възникна неочаквана грешка. Моля, опитайте да обновите страницата.',
      retry: 'Повторен опит',
    },
    // ExportButton
    exportButton: {
      export: 'Експортиране',
      exporting: 'Експортиране...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Печат',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Чернова',
      review: 'Преглед',
      published: 'Публикувано',
      selection: 'Избор',
      inTransit: 'В транзит',
      completed: 'Завършено',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Онлайн инстанция',
      message: 'Режим само за четене. Данните се синхронизират от основния сървър.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Преглеждате като',
      loggedInAs: 'влезли като {{nation}}',
      returnTo: 'Връщане към {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Търсене на страници, заявки, транспорти...',
      searching: 'Търсене...',
      noResults: 'Няма резултати за „{{query}}"',
      navigate: 'Навигиране',
      select: 'Избиране',
      close: 'Затваряне',
      pages: {
        dashboard: 'Табло',
        requests: 'Заявки',
        transports: 'Транспорти',
        map: 'Карта',
        myPatients: 'Моите пациенти',
        flowDiagram: 'Диаграма на потока',
        statistics: 'Статистики',
        assets: 'Ресурси',
        startPoints: 'Начални точки / Възли',
        treatmentFacilities: 'Лечебни заведения',
        users: 'Потребители',
        settings: 'Настройки',
        auditLogs: 'Одитен журнал',
        exerciseControl: 'Управление на учението',
        dataSync: 'Синхронизация на данни',
        patientImport: 'Импорт на пациенти',
        notifications: 'Известия',
        documentation: 'Документация',
      },
      actions: {
        importPatientsJson: 'Импортиране на Пациенти (JSON)',
        importPatientsExcel: 'Импортиране на Пациенти (Excel)',
        importUsers: 'Импортиране на Потребители (Excel)',
        importAssetTemplates: 'Импортиране на Шаблони за активи (Excel)',
        importDayTemplates: 'Импортиране на Записи за дневен шаблон (Excel)',
        exportRequests: 'Експортиране на Заявки (Excel)',
        exportPatients: 'Експортиране на Пациенти (Excel)',
        exportUsers: 'Експортиране на Потребители (Excel)',
        exportCredentials: 'Експортиране на Удостоверения (PDF)',
        exportAuditExcel: 'Експортиране на Одитен дневник (Excel)',
        exportAuditPdf: 'Експортиране на Одитен дневник (PDF)',
        pagePatientImport: 'Страница за импорт на пациенти',
        pageRequestDetail: 'Страница за детайли на заявка',
        pageUsers: 'Страница за управление на потребители',
        pageAssetTemplates: 'Страница за шаблони за активи',
        pageDayTemplates: 'Страница за дневни шаблони',
        pageRequests: 'Страница за списък със заявки',
        pageAuditLogs: 'Страница за одитен дневник',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Сесията изтича',
      message: 'Вашата сесия ще изтече след <strong>{{time}}</strong>. Моля, запазете работата си и влезте отново.',
      dismiss: 'Затваряне',
      logoutNow: 'Излизане сега',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Изберете 4 часови зони',
      configure: 'Настройка на часови зони',
      reset: 'Нулиране',
      apply: 'Прилагане',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Избиране на местоположение',
      latitude: 'Географска ширина',
      longitude: 'Географска дължина',
      clickToSelect: 'Натиснете върху картата, за да изберете местоположение',
    },
    // Modal
    modal: {
      close: 'Затваряне',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Начало',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Поддръжка на системата',
    message: 'Системата се нулира за следващия ден на учението. Моля, изчакайте до завършване на процеса.',
    autoRefresh: 'Тази страница ще се обнови автоматично, когато системата отново стане достъпна.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Поне 10 символа',
    uppercase: '1 главна буква',
    lowercase: '1 малка буква',
    digit: '1 цифра',
    special: '1 специален символ',
  },
};

export default bg;
